import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Loader from '../../components/custom/loader'
import { NavLink } from 'react-router-dom'
import { getCollection, checkA } from '../../constant';
import PieChart from 'react-minimal-pie-chart';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import IconButton from '@material-ui/core/IconButton';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const styles = {
  paper: {
    margin: 4,
    padding: 10
  },
  cText: { textAlign: 'center' },
  main: {
    maxWidth: '1200px',
    margin: 'auto',
    width: '80%',
    marginTop: 50
  },
  link: {
    display: 'block',
    color: 'inherit',
    textDecoration: 'none'
  },
  colorShow: {
    width: 12,
    height: 12,
    display: 'inline-block',
    marginLeft: 15,
    marginRight: 5
  }
};

class Dashboard extends Component {

  render() {
    const { projects = [], auth, profile, tasks = [], roles, users = [] } = this.props

    const cell = {
      xs: 12,
      sm: 6,
      md: 3
    }

    if (!auth.uid) return <Redirect to='/signin' />

    if (!isLoaded(profile) || !isLoaded(projects) || !isLoaded(tasks)) {
      return <Loader />
    }

    return (
      <div style={styles.main}>
        {
          ((projects && projects.length > 0) || (tasks && tasks.length > 0))
          ?
          < div >
            <Grid container spacing={3}>
              {
                projects && projects.length > 0
                &&
                <Grid item {...cell}>
                  <NavLink style={styles.link} to="/projects" >
                    <PieChart {...getNum(projects, true)} />
                  </NavLink>
                </Grid>
              }

              {
                tasks && tasks.length > 0
                &&
                <Grid item {...cell}>
                  <NavLink style={styles.link} to="/tasks" >
                    <PieChart {...getNum(tasks, true)} />
                  </NavLink>
                </Grid>
              }
            </Grid>
            <Grid container spacing={3}>
              <Grid item {...cell}>
                <p style={{ textAlign: 'center' }}>Projects({projects.length})</p>
              </Grid>
              <Grid item {...cell}>
                <p style={{ textAlign: 'center' }}>Tasks({tasks.length})</p>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <p style={{ marginTop: 10, marginLeft: 40 }}>
                <span style={{ ...styles.colorShow, background: '#3f51b5' }}></span> Active
              <span style={{ ...styles.colorShow, background: 'rgba(0, 0, 0, 0.14)' }}></span>  Complete
          </p>
            </Grid>
          </div>

          :
          <Typography variant="h5">There are no data to show</Typography>
        }

        {
          checkA(profile)
          &&
          <TableContainer style={{ marginTop: 20, marginBottom: 20 }} component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Projects(As Manager)</TableCell>
                  <TableCell>Projects(As Assignee)</TableCell>
                  <TableCell>Tasks</TableCell>
                  <TableCell>View</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map(({ id, displayName, role }) => {
                  return (
                    <TableRow key={id}>
                      <TableCell>{displayName}</TableCell>
                      <TableCell>{role}</TableCell>
                      <TableCell>{findCount(projects, id, 'manager')}</TableCell>
                      <TableCell>{findCount(projects, id)}</TableCell>
                      <TableCell>{findCount(tasks, id)}</TableCell>
                      <TableCell>
                        <NavLink style={styles.link} to={"/user-dashboard/" + id} >
                          <IconButton>
                            <OpenInNewIcon />
                          </IconButton>
                        </NavLink>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        }

      </div >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    projects: state.firestore.ordered[getCollection(state.firebase.profile, 'projects')],
    tasks: state.firestore.ordered[getCollection(state.firebase.profile, 'tasks')],
    users: state.firestore.ordered.users,
    roles: state.firestore.ordered.roles,
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {

    const user = {
      collection: 'users',
      where: ['organization.id', '==', props.profile.organization && props.profile.organization.id || 'Jassu']
    };
    if (checkA(props.profile)) {
      return [
        { collection: getCollection(props.profile, 'tasks') },
        { collection: getCollection(props.profile, 'projects')},
        user
      ]
    } else if (props.profile.id) {
      return [
        {
          collection: getCollection(props.profile, 'tasks'),
          where: ['assigneeIds', 'array-contains', props.profile.id],
        },
        {
          collection: getCollection(props.profile, 'projects'),
          where: ['assigneeIds', 'array-contains', props.profile.id],
        },
      ]
    } else {
      return []
    }
  })
)(Dashboard)


function findCount(data, userId, keyName = 'assignee') {

  let active = 0;
  let complete = 0;
  data.forEach(obj => {
    if (keyName == 'assignee') {
      obj.assignee.forEach(a => {
        if (a.id == userId) {
          if (!obj.complete) active++;
          if (obj.complete) complete++;
        }
      });
    }
    if (keyName == 'manager') {
      if (obj.manager.id == userId) {
        if (!obj.complete) active++;
        if (obj.complete) complete++;
      }
    }
  });

  return `Active: ${active}, Complete: ${complete}`
}


function getNum(data, graphData) {
  let active = 0;
  let complete = 0;
  data.forEach(obj => {
    if (!obj.complete) active++;
    if (obj.complete) complete++;
  });

  if (graphData) {

    const pieChartStyle = {
      label: true,
      labelStyle: {
        fontSize: '12px',
        fontFamily: 'sans-serif',
        fill: '#fff'
      },
      animate: true,
      animationDuration: 500,
      animationEasing: "ease-out",
      cx: 50,
      cy: 50,
    };

    let gData = []

    if (active) {
      gData.push({ title: 'Active', value: active, color: '#3f51b5' })
    }

    if (complete) {
      gData.push({ title: 'Complete', value: complete, color: 'rgba(0, 0, 0, 0.14)' })
    }

    if (gData.length == 1) {
      pieChartStyle.label = false;
    }

    return { data: gData, ...pieChartStyle };
  } else {
    return { active, complete };
  }

}